import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { OfferCardProvider } from '@/providers/OfferCardProvider';
import { OfferCardDesktop } from './OfferCardDesktop';
export function OfferCardsDesktop({ offerCards }) {
    const generateCardsLayout = () => {
        return offerCards.map((offerCard) => (_jsx(OfferCardProvider, { offerCard: offerCard, children: _jsx(OfferCardDesktop, { offerCard: offerCard }) }, offerCard.id)));
    };
    return (_jsx(Box, { testId: "offer-cards-desktop", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "spacing.32", marginTop: "spacing.32", marginBottom: "spacing.56", justifyItems: "center", width: "fit-content", marginHorizontal: "auto", children: generateCardsLayout() }));
}
